/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import {ActionDefinitionModel} from "./action-definition.model";

export class SubscriptionTypeVoModel extends JSONable {

  uuid: string | undefined = undefined;

  typeName: string | undefined = undefined;

  subscriptionPrice: string | undefined = undefined;

  subscriptionCurrency: string | undefined = undefined;

  pricePerExtraCredit: number | undefined = undefined;

  private: boolean | undefined = undefined;

  creditStart: string | undefined = undefined;

  actionDefinitionVos: ActionDefinitionModel[] | undefined = undefined;

  companyType: string | undefined = undefined;

  details: string | undefined = undefined;

}
